export default {
    "base": {
        "labelWidth": "65px",
        "mode": "1",
        "isShowTable": true
    },
    "search": [],
    "props": [
        {
            "label": "文章名",
            "prop": "article_title",
        },
		{
		    "label": "作者",
		    "prop": "author"
		},
        {
            "label": "征文主题",
            "prop": "ext_param1"
        },
        // {
        //     "label": "奖项",
        //     "prop": "reward"
        // },
   //      {
   //          "label": "状态",
   //          "prop": "status",
			// "width":"180px"
   //      },
        {
            "label": "投稿时间",
            "prop": "add_time"
         },
        // {
        //     "label": "操作",
        //     "prop": "oper"
        // }
    ]
}